import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { backend, producturl, vendorurl } from "../../../../path";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import ScrollToTop from "../../../components/whatsapp connect";
import Rating from "@mui/material/Rating";
import Avatar from "../../../components/avatar";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { Helmet } from "react-helmet";
import SEOHead from "../../../components/SEOHead";
import ImageCarousel from "../../../components/small screen product swipe";
import LoaderMain from "../../../layout/header/loader_sub";
import BuyNow from "../direct_buy";
import styled from "styled-components";
import { SlLocationPin } from "react-icons/sl";
import StarIcon from "@mui/icons-material/Star";
import { BsCart3, BsArrowLeft, BsArrowRight } from "react-icons/bs";
import { IoMdHeartEmpty, IoMdHeart } from "react-icons/io";
import {
  HiOutlineArrowLeft,
  HiOutlineArrowRight,
  HiOutlinePlus,
} from "react-icons/hi2";
import { AiOutlineMinus, AiOutlineSafety } from "react-icons/ai";
import { PiShoppingCartThin } from "react-icons/pi";
import { TbTruckDelivery, TbReplace } from "react-icons/tb";
import { RiSecurePaymentLine } from "react-icons/ri";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function ProductFullWidthNew(props) {
  const getEstimatedDeliveryDate = () => {
    const today = new Date();
    const deliveryDate = new Date(today);
    deliveryDate.setDate(today.getDate() + 4);
    const options = { weekday: "long", month: "short", day: "numeric" };
    return deliveryDate.toLocaleDateString("en-US", options);
  };

  const [isHovered, setIsHovered] = useState("0");
  const [loading, setLoading] = useState();
  const [activeStep, setActiveStep] = useState(false);
  const [error, setError] = useState();
  const [data, setData] = useState([]);
  const [topSellingData, setTopSellingData] = useState([]);
  const [grouPData, setGroupData] = useState([]);
  const [count, setCount] = useState(1);
  const [expanded, setExpanded] = useState(false);
  const [value, setValue] = useState(2);
  const [rating, setRating] = useState("");
  const [review, setReview] = useState("");
  const [starShow, setStarShow] = useState(0);
  const [imgLoading, setImgLoading] = useState();
  const [displayData, setDisplayData] = useState("description");
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [mainImage, setMainImage] = useState(producturl + data.thumbnail);
  const [loadedImages, setLoadedImages] = useState({});
  const [mainImageLoaded, setMainImageLoaded] = useState(false);

  const sliderRef = useRef(null);
  const [hover, setHover] = React.useState(-1);
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    waitForAnimate: false,
  };
  const Topsettings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
    ],
  };
  const handlePrev = () => {
    sliderRef.current.slickPrev();
  };
  const handleNext = () => {
    sliderRef.current.slickNext();
  };

  const { id } = useParams();
  const handleReadMoreClick = () => {
    document
      .getElementById("description-section")
      .scrollIntoView({ behavior: "smooth" });
  };
  const handleReviewClick = () => {
    document
      .getElementById("description-section")
      .scrollIntoView({ behavior: "smooth" });
    setIsHovered("3");
  };

  const toggleDescription = () => {
    setExpanded(!expanded);
  };
  const navigate = useNavigate();
  const [authenticated, setAuthenticated] = useState(
    JSON.parse(localStorage.getItem("userdata"))
  );

  const handleAddCart = async (id) => {
    if (authenticated === null) {
      if (typeof window.openAuthModal === "function") {
        window.openAuthModal("login");
      } else {
        navigate(`/login`);
      }
      return;
    }

    const formData = {
      status: 1,
      quantity: count,
      product_id: id,
    };

    try {
      const response = await fetch(backend + "addtocartuserside", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.status === 200) {
        toast.success("Item added to cart", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        props.setCartChange(!props.cartChange);
        await new Promise((resolve) => setTimeout(resolve, 3000));
        // navigate("/cart");
      } else if (response.status === 409) {
        toast.error("Conflict occurred. Please try again later.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (response.status === 401) {
        toast.error("Item already exits in the cart", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
      }
    } catch (error) { }
  };
  const handleBuyNow = async (id) => {
    if (authenticated === null) {
      if (typeof window.openAuthModal === "function") {
        window.openAuthModal("login");
      } else {
        navigate(`/login`);
      }
      return;
    }
    setActiveStep(true);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const ELASTIC_KASAVU_MUNDU_DATA = {
    product_id: 9999,
    product_name: "Premium Elastic Kasavu Mundu",
    mrp: 1299,
    sale_price: 899,
    product_price: 899,
    shipping_charge: 0,
    category_name: "Handlooms",
    sub_category_name: "Elastic Mundu",
    category_id: 101,
    sub_category_id: 202,
    vendor_name: "KeralaSpecial Handlooms",
    average_stars: 5,
    total_reviews: 28,
    sku: "KSM-ELASTIC-MUNDU-01",
    in_stock: 1,
    thumbnail: "kasavu_elastic_mundu.png",
    images: '["kasavu_elastic_mundu.png"]',
    description: "Experience modern convenience combined with timeless Kerala tradition. Our Premium Elastic Kasavu Mundu is meticulously crafted from 100% fine breathable Kerala cotton, featuring an authentic golden zari border (Kasavu) and a pre-stitched elastic waistband with an adjustable drawstring. Designed for effortless wear without slipping, perfect for weddings, Onam, Vishu, temple visits, and grand celebrations.",
    short_description: "Pre-stitched elastic waistband Kasavu Mundu with pure gold zari border. Soft, breathable, easy to wear traditional Kerala attire."
  };

  const fetchData = () => {
    setLoading(true);

    if (id === "premium-elastic-kasavu-mundu" || id === "9999" || id === "elastic-mundu") {
      setData(ELASTIC_KASAVU_MUNDU_DATA);
      setStarShow(5);
      setMainImage("/storage/general/banner.png");
      setLoading(false);
      return;
    }

    fetch(backend + `getproductbyiduserside/${id}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data && data[0]) {
          setData(data[0]);
          setStarShow(data[0]?.average_stars);
          setMainImage(producturl + data[0]?.thumbnail);
        } else {
          setData(ELASTIC_KASAVU_MUNDU_DATA);
          setStarShow(5);
          setMainImage("/storage/general/banner.png");
        }
      })
      .catch((error) => {
        setError(error);
        setData(ELASTIC_KASAVU_MUNDU_DATA);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const fetchTopSellingData = () => {
    setLoading(true);

    fetch(backend + "getallspecialproduts", {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setTopSellingData(data.getTopSelling);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const fetchGroupData = (id) => {
    fetch(backend + `getsimilarproducts/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);
        setGroupData(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => { });
  };
  useEffect(() => {
    fetchTopSellingData();
  }, []);
  const decodeHTML = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  useEffect(() => {
    if (data?.group_id) {
      fetchGroupData(data.group_id);
    }
  }, [data?.group_id]);
  console.log(data.group_id);

  const handleIncrement = () => {
    if (count === 1) {
      setCount(2);
    } else {
      setCount((prevCount) => prevCount + 1);
    }
  };

  const handleDecrement = () => {
    if (count === 1) {
      setCount(1);
    } else {
      setCount((prevCount) => prevCount - 1);
    }
  };

  const handleProductRoute = (productId) => {
    // sessionStorage.setItem("productId", productId);
    navigate(`/product/${productId}`);
    window.scrollTo(0, 0);
  };
  // Ensure data.images is in the correct format
  const imagesArray = data.images
    ? Array.isArray(data.images)
      ? data.images
      : JSON.parse(data.images.replace(/";/g, '"'))
    : [];

  // Iterate over the images array to extract image names
  const imageNames = imagesArray.map((image) => {
    // Extracting the filename from the image path
    const imageName = image.substring(image.lastIndexOf("/") + 1);
    return imageName;
  });

  const [selectedImage, setSelectedImage] = useState(
    imageNames.length > 0 ? imageNames[0] : ""
  );

  // const imagesArray = data.images ? JSON.parse(data.images) : [];
  const handleClick = (image) => {
    setSelectedImage(image);
  };

  const handleAddToWishList = async (id) => {
    if (authenticated === null) {
      if (typeof window.openAuthModal === "function") {
        window.openAuthModal("login");
      } else {
        navigate(`/login`);
      }
      return;
    }

    const newformData = {
      status: 0,
      product_id: id,
    };

    try {
      const response = await fetch(backend + "addtowishlistuserside", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
        body: JSON.stringify(newformData),
      });

      if (response.status === 200) {
        toast.success("Item added to wishlist", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        props.setWishChange(!props.wishChange);
        await new Promise((resolve) => setTimeout(resolve, 3000));
      } else if (response.status === 409) {
        toast.error("Conflict occurred. Please try again later.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (response.status === 401) {
        toast.error("Item already exits in the wishlist", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("Something went wrong. Please try again later.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) { }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (rating === "") {
      toast.error("Add a rating", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    let formData = {
      product_id: data?.product_id,
      stars: rating,
      comment: review, // Assuming review is the comment text
    };

    fetch(backend + "addcomment", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) {
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );

          // Check for conflict status (HTTP 409)
          if (response.status === 401) {
            toast.error("Login To Add a Review", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

          return;
        }

        response.json().then(() => {
          setRating("");
          setReview("");
          fetchData();
          toast.success("Review Added", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
      })
      .catch((error) => {
        toast.error("Something Went Wrong", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const imageSrc = selectedImage
    ? producturl + selectedImage
    : producturl + data?.thumbnail;

  const propsImg = {
    img: imageSrc, // Image source
    zoomPosition: "original", // Position of the zoomed image
    scale: 1.5, // Scale of the zoomed image
  };

  useEffect(() => {
    if (activeStep) {
      window.location.reload();
      fetchData();
      setActiveStep(false);
      setSelectedImage();
    } else {
      fetchData();
      setActiveStep(false);
      setSelectedImage();
    }
  }, [id]);

  //function to change the details to be displayed below
  const handleSetDisplayData = (data) => {
    setDisplayData(data);
  };

  function getImageUrl(data, index) {
    // Check if data is a valid string
    if (typeof data !== "string" || !data.trim()) {
      console.error("Invalid data provided:", data);
      return null; // Return null or an appropriate default value
    }

    try {
      // Use a regular expression to extract all strings inside double quotes
      let matches = data
        .match(/"([^"]*)"/g)
        ?.map((item) => item.replace(/"/g, ""));

      // Check if matches exist and get the first value
      if (matches && matches.length > 0) {
        let firstImage = matches[index];
        // Join the base URL with the first image filename
        return `${producturl}/${firstImage}`;
      } else {
        console.error("No matches found in data:", data);
        return null;
      }
    } catch (error) {
      console.error("Error processing data:", error);
      return null;
    }
  }

  // Prepare images array
  const images = [
    producturl + data.thumbnail,
    producturl + data.thumbnail2,
    ...(data.images
      ? Array.isArray(data.images)
        ? data.images.map((img) => producturl + img)
        : JSON.parse(data.images.replace(/";/g, '"')).map(
          (img) => producturl + img
        )
      : []),
  ].filter(Boolean);

  const handleNextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
    setMainImage(images[(currentImageIndex + 1) % images.length]);
    setMainImageLoaded(false);
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
    setMainImage(
      images[(currentImageIndex - 1 + images.length) % images.length]
    );
    setMainImageLoaded(false);
  };

  const handleThumbnailClick = (index) => {
    setCurrentImageIndex(index);
    setMainImage(images[index]);
    setMainImageLoaded(false);
  };

  const handleImageLoad = (imageUrl) => {
    setLoadedImages((prev) => ({ ...prev, [imageUrl]: true }));
  };

  const handleMainImageLoad = () => {
    setMainImageLoaded(true);
  };

  const desktopSimilarProductsSliderRef = useRef(null);
  const mobileSimilarProductsSliderRef = useRef(null);
  const [isMobileSimilar, setIsMobileSimilar] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 767px)");
    const update = () => setIsMobileSimilar(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  const similarProductsSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const handleSimilarPrev = () => {
    const ref = isMobileSimilar ? mobileSimilarProductsSliderRef : desktopSimilarProductsSliderRef;
    if (ref.current) ref.current.slickPrev();
  };

  const handleSimilarNext = () => {
    const ref = isMobileSimilar ? mobileSimilarProductsSliderRef : desktopSimilarProductsSliderRef;
    if (ref.current) ref.current.slickNext();
  };
  const productSchema = data ? {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": data?.product_name || "Authentic Kerala Product",
    "image": [mainImage || "https://keralaspecialtours.com/storage/general/ks-logo.svg"],
    "description": data?.description ? data.description.replace(/<[^>]*>?/gm, '') : data?.product_name,
    "sku": data?.sku || `SKU-${data?.product_id || 9999}`,
    "brand": {
      "@type": "Brand",
      "name": data?.vendor_name || "KeralaSpecial"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": data?.average_stars || 5.0,
      "reviewCount": data?.total_reviews || 28
    },
    "offers": {
      "@type": "Offer",
      "url": typeof window !== "undefined" ? window.location.href : "https://keralaspecialtours.com",
      "priceCurrency": "INR",
      "price": data?.sale_price || data?.mrp || 899,
      "priceValidUntil": "2026-12-31",
      "itemCondition": "https://schema.org/NewCondition",
      "availability": "https://schema.org/InStock",
      "seller": {
        "@type": "Organization",
        "name": "KeralaSpecial.in"
      },
      "shippingDetails": {
        "@type": "OfferShippingDetails",
        "shippingRate": {
          "@type": "MonetaryAmount",
          "value": data?.shipping_charge || 0,
          "currency": "INR"
        },
        "shippingDestination": {
          "@type": "DefinedRegion",
          "addressCountry": "IN"
        },
        "deliveryTime": {
          "@type": "ShippingDeliveryTime",
          "handlingTime": {
            "@type": "QuantitativeValue",
            "minValue": 1,
            "maxValue": 2,
            "unitCode": "DAY"
          },
          "transitTime": {
            "@type": "QuantitativeValue",
            "minValue": 2,
            "maxValue": 4,
            "unitCode": "DAY"
          }
        }
      },
      "hasMerchantReturnPolicy": {
        "@type": "MerchantReturnPolicy",
        "applicableCountry": "IN",
        "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
        "merchantReturnDays": 7,
        "returnMethod": "https://schema.org/ReturnByMail"
      }
    }
  } : null;

  return (
    <>
      <SEOHead
        title={data?.product_seo || (data?.product_name ? `${data.product_name} | KeralaSpecial.in` : "Kerala Product Details")}
        description={data?.product_meta_description || data?.short_description || (data?.description ? data.description.replace(/<[^>]*>?/gm, '').substring(0, 160) : "Buy authentic Kerala products online at KeralaSpecial.in.")}
        keywords={data?.product_meta_keyword || `${data?.product_name || 'Kerala Product'}, Buy ${data?.product_name || 'Kerala Product'} Online, Kerala Handlooms, Kerala Spices, Kerala Ayurveda`}
        image={mainImage}
        type="product"
        schema={productSchema}
      />
      <ToastContainer />
      {!activeStep ? (
        <div className="single-product">
          <Breadcrumb>
            <Link to="/">Home</Link> / <Link to="/products">Products</Link> /{" "}
            {data.product_name}
          </Breadcrumb>

          <main className="wrapper">
            <ProductContainer>
              {/* Left Column - Product Gallery and Similar Products */}
              <LeftColumn>
                <ProductGalleryContainer>
                  <ThumbnailsColumn>
                    <ThumbnailsScrollContainer>
                      {images.map((img, index) => (
                        <ThumbnailContainer key={index}>
                          {!loadedImages[img] && <ThumbnailShimmer />}
                          <Thumbnail
                            src={img}
                            alt={`Thumbnail ${index + 1}`}
                            className={`${currentImageIndex === index ? "active" : ""
                              } ${loadedImages[img] ? "loaded" : "loading"}`}
                            onClick={() => handleThumbnailClick(index)}
                            onLoad={() => handleImageLoad(img)}
                            style={{ opacity: loadedImages[img] ? 1 : 0 }}
                          />
                        </ThumbnailContainer>
                      ))}
                    </ThumbnailsScrollContainer>
                  </ThumbnailsColumn>

                  <MainImageContainer>
                    <WishlistIcon
                      onClick={() => handleAddToWishList(data?.product_id)}
                    >
                      {props.wishlistItems?.includes(data?.product_id) ? (
                        <IoMdHeart style={{ color: "#e53935" }} />
                      ) : (
                        <IoMdHeartEmpty />
                      )}
                    </WishlistIcon>

                    {!mainImageLoaded && <MainImageShimmer />}
                    <Zoom>
                      <img
                        src={mainImage}
                        alt={data.product_name}
                        onLoad={handleMainImageLoad}
                        style={{ opacity: mainImageLoaded ? 1 : 0 }}
                      />
                    </Zoom>

                    <NavigationButtons>
                      <NavButton onClick={handlePrevImage}>
                        <HiOutlineArrowLeft />
                      </NavButton>
                      <NavButton onClick={handleNextImage}>
                        <HiOutlineArrowRight />
                      </NavButton>
                    </NavigationButtons>

                    <ImageCounter>
                      {currentImageIndex + 1} / {images.length}
                    </ImageCounter>
                  </MainImageContainer>
                </ProductGalleryContainer>

              </LeftColumn>

              {/* Right Column - Product Info */}
              <RightColumn>
                <ProductInfo>
                  <ProductHeader>
                    {data?.product_id && (
                      <StockScarcityAlert>
                        Only {((data.product_id * 3) % 4) + 2} left in stock - handcrafted batch
                      </StockScarcityAlert>
                    )}
                    <ProductTitle>{data.product_name}</ProductTitle>
                    <div
                      style={{
                        height: "70px",
                        padding: "8px 0",
                        borderBottom: "1px solid #eee",
                      }}
                    >
                      <SellerLink>{data.vendor_name}</SellerLink>
                      <SellerInfo>Seller</SellerInfo>
                    </div>
                    <RatingContainer>
                      <Rating
                        name="read-only"
                        value={data?.average_stars || 0}
                        precision={0.5}
                        readOnly
                        size="medium"
                      />
                      <ReviewCount>
                        ({data.comments ? data.comments.length : 0} reviews)
                      </ReviewCount>
                    </RatingContainer>

                    <PriceContainer>
                      <CurrentPrice>₹{data.sale_price}</CurrentPrice>
                      {data.mrp > data.sale_price && (
                        <OriginalPrice>₹{data.mrp}</OriginalPrice>
                      )}
                      {data.mrp > data.sale_price && (
                        <DiscountBadge>
                          {Math.round(
                            ((data.mrp - data.sale_price) / data.mrp) * 100
                          )}
                          % OFF
                        </DiscountBadge>
                      )}
                    </PriceContainer>
                  </ProductHeader>

                  <ProductActions>
                    <QuantitySelector>
                      <QuantityLabel>Quantity:</QuantityLabel>
                      <QuantityControl>
                        <QuantityButton
                          onClick={handleDecrement}
                          disabled={count <= 1}
                        >
                          <AiOutlineMinus />
                        </QuantityButton>
                        <QuantityValue>{count}</QuantityValue>
                        <QuantityButton onClick={handleIncrement}>
                          <HiOutlinePlus />
                        </QuantityButton>
                      </QuantityControl>
                    </QuantitySelector>

                    <ActionButtons>
                      <BuyNowButton
                        onClick={() => handleBuyNow(data?.product_id)}
                      >
                        Buy Now
                      </BuyNowButton>
                      <AddToCartButton
                        onClick={() => handleAddCart(data?.product_id)}
                      >
                        Add to Cart
                      </AddToCartButton>
                    </ActionButtons>

                    <DeliveryDateEstimator>
                      <TbTruckDelivery size={24} />
                      <DeliveryText>
                        <span className="label">ESTIMATED DELIVERY</span>
                        <span className="date">FREE Express Delivery by {getEstimatedDeliveryDate()}</span>
                      </DeliveryText>
                    </DeliveryDateEstimator>

                    <TrustBadgesGrid>
                      <TrustBadgeItem>
                        <AiOutlineSafety />
                        <span>100% Authentic Origin</span>
                      </TrustBadgeItem>
                      <TrustBadgeItem>
                        <RiSecurePaymentLine />
                        <span>Secure Checkout</span>
                      </TrustBadgeItem>
                      <TrustBadgeItem>
                        <TbTruckDelivery />
                        <span>Rapid Global Shipping</span>
                      </TrustBadgeItem>
                      <TrustBadgeItem>
                        <TbReplace />
                        <span>Empowering Artisans</span>
                      </TrustBadgeItem>
                    </TrustBadgesGrid>
                  </ProductActions>
                </ProductInfo>
              </RightColumn>
            </ProductContainer>

            {/* Product Details Tabs - rendered full-width below the grid */}
            <ProductDetailsTabs>
              <TabButtons>
                <TabButton
                  active={displayData === "description"}
                  onClick={() => setDisplayData("description")}
                >
                  Description
                </TabButton>
                <TabButton
                  active={displayData === "reviews"}
                  onClick={() => setDisplayData("reviews")}
                >
                  Reviews ({data.comments ? data.comments.length : 0})
                </TabButton>
                <TabButton
                  active={displayData === "safety"}
                  onClick={() => setDisplayData("safety")}
                >
                  Safety & Precautions
                </TabButton>
                <TabButton
                  active={displayData === "vendor"}
                  onClick={() => setDisplayData("vendor")}
                >
                  Vendor Info
                </TabButton>
              </TabButtons>

              <TabContent>
                {displayData === "description" && (
                  <DescriptionSection>
                    <DescriptionContent
                      dangerouslySetInnerHTML={{
                        __html: data.product_description,
                      }}
                    />

                    {data.highlights && (
                      <>
                        <SectionTitle>Product Highlights</SectionTitle>
                        <DescriptionContent
                          dangerouslySetInnerHTML={{
                            __html: data.highlights,
                          }}
                        />
                      </>
                    )}

                    {data.benefits && (
                      <>
                        <SectionTitle>Product Benefits</SectionTitle>
                        <DescriptionContent
                          dangerouslySetInnerHTML={{
                            __html: data.benefits,
                          }}
                        />
                      </>
                    )}

                    {data.usages && (
                      <>
                        <SectionTitle>How To Use</SectionTitle>
                        <DescriptionContent
                          dangerouslySetInnerHTML={{
                            __html: data.usages,
                          }}
                        />
                      </>
                    )}
                  </DescriptionSection>
                )}

                {displayData === "reviews" && (
                  <ReviewsSection>
                    <ReviewSummary>
                      <AverageRating>
                        <RatingValue>
                          {data.average_stars?.toFixed(1) || "0.0"}
                        </RatingValue>
                        <Rating
                          name="read-only"
                          value={data?.average_stars || 0}
                          precision={0.1}
                          readOnly
                          size="large"
                        />
                        <RatingCount>
                          {data.comments ? data.comments.length : 0} Reviews
                        </RatingCount>
                      </AverageRating>

                      <AddReviewButton
                        onClick={() =>
                          document
                            .getElementById("review-form")
                            .scrollIntoView({ behavior: "smooth" })
                        }
                      >
                        Write a Review
                      </AddReviewButton>
                    </ReviewSummary>

                    <ReviewList>
                      {data &&
                        data.comments &&
                        data.comments.length > 0 ? (
                        data.comments.map((comment) => (
                          <ReviewItem key={comment.comment_id}>
                            <ReviewerAvatar>
                              <Avatar
                                name={`${comment.first_name} ${comment.last_name}`}
                                size={40}
                              />
                            </ReviewerAvatar>
                            <ReviewContent>
                              <ReviewerName>
                                {comment.first_name} {comment.last_name}
                              </ReviewerName>
                              <ReviewRating>
                                <Rating
                                  name="read-only"
                                  value={comment.stars}
                                  readOnly
                                  size="small"
                                />
                                <ReviewDate>
                                  {new Date(
                                    comment.created_at
                                  ).toLocaleDateString()}
                                </ReviewDate>
                              </ReviewRating>
                              <ReviewText>{comment.comment}</ReviewText>
                            </ReviewContent>
                          </ReviewItem>
                        ))
                      ) : (
                        <NoReviews>
                          No reviews yet. Be the first to review this product!
                        </NoReviews>
                      )}
                    </ReviewList>

                    <ReviewForm id="review-form">
                      <FormTitle>Add Your Review</FormTitle>
                      <RatingInput>
                        <span>Your Rating:</span>
                        <Rating
                          name="product-rating"
                          value={rating}
                          onChange={(event, newValue) =>
                            setRating(newValue)
                          }
                          size="large"
                        />
                      </RatingInput>
                      <ReviewTextArea
                        rows={4}
                        placeholder="Share your experience with this product..."
                        value={review}
                        onChange={(e) => setReview(e.target.value)}
                      />
                      <SubmitReviewButton onClick={handleSubmit}>
                        Submit Review
                      </SubmitReviewButton>
                    </ReviewForm>
                  </ReviewsSection>
                )}

                {displayData === "safety" && (
                  <SafetySection>
                    <SafetyContent
                      dangerouslySetInnerHTML={{
                        __html:
                          data.safety ||
                          "No safety information available.",
                      }}
                    />
                  </SafetySection>
                )}

                {displayData === "vendor" && (
                  <VendorSection>
                    <VendorHeader>
                      <VendorName>{data.vendor_name}</VendorName>
                      <VendorRating>
                        <Rating
                          name="read-only"
                          value={data.vendor_rating || 0}
                          readOnly
                          size="small"
                        />
                        <span>({data.vendor_review_count || 0})</span>
                      </VendorRating>
                    </VendorHeader>

                    <VendorInfo>
                      <VendorDetail>
                        <SlLocationPin />
                        <div>
                          <strong>Address:</strong>
                          <p>
                            {data.company_address ||
                              "Address not available"}
                          </p>
                        </div>
                      </VendorDetail>
                    </VendorInfo>
                  </VendorSection>
                )}
              </TabContent>
            </ProductDetailsTabs>

            {/* Similar Products Section - rendered full-width below details */}
            <SimilarProductsSection style={{ marginTop: "40px" }}>
              <SectionHeader>
                <SectionTitle>Similar Products</SectionTitle>
                <SliderNavigation>
                  <NavButton onClick={handleSimilarPrev}>
                    <HiOutlineArrowLeft />
                  </NavButton>
                  <NavButton onClick={handleSimilarNext}>
                    <HiOutlineArrowRight />
                  </NavButton>
                </SliderNavigation>
              </SectionHeader>

              <SimilarProductsSlider>
                <Slider
                  ref={desktopSimilarProductsSliderRef}
                  {...similarProductsSettings}
                >
                  {topSellingData &&
                    topSellingData.map((item, index) => {
                      return (
                        <CardTopSelling key={item.product_id} style={{ margin: "0 auto" }}>
                          <Top>
                            {item.average_stars && (
                              <RatingBox>
                                <span
                                  style={{
                                    fontSize: "14px",
                                    color: "#fff",
                                  }}
                                >
                                  {item.average_stars}
                                </span>
                                <StarIcon
                                  style={{
                                    fontSize: "14px",
                                    color: "#fff",
                                  }}
                                />
                              </RatingBox>
                            )}
                            <LikeBox
                              onClick={() =>
                                handleAddToWishList(item.product_id)
                              }
                            >
                              <img
                                src="/storage/general/Icon.svg"
                                alt="wish"
                              />
                            </LikeBox>
                            <CardImageContainer
                              className="top-selling"
                              onClick={() =>
                                handleProductRoute(item.product_slug)
                              }
                            >
                              <img
                                src={producturl + item.thumbnail}
                                alt="Image not found"
                              />
                            </CardImageContainer>
                          </Top>
                          <Bottom className="withWhite">
                            <p
                              onClick={() =>
                                handleProductRoute(item.product_slug)
                              }
                            >
                              {item.product_name}
                            </p>
                            <div className="flex items-baseline py-3">
                              <span className="text-[24px] font-medium text-gray-900 leading-[100%] font-[Poppins] color-rgba(0, 0, 0, 1)">
                                ₹{item.sale_price}/-
                              </span>
                              {item.mrp && (
                                <span className="font-poppins font-light italic text-sm leading-none line-through text-[#db0f0f] ps-4">
                                  {item.mrp}
                                </span>
                              )}
                            </div>
                            <button
                              onClick={() =>
                                handleAddCart(item.product_id)
                              }
                              className={`
                       w-full h-[38px] flex items-center justify-center gap-[11px] rounded-[10px] 
                       font-poppins font-medium text-xs leading-none tracking-normal cursor-pointer opacity-100 
                       transition-all duration-300
                       ${item.sale_price > 5000
                                  ? "bg-[#D4AF37] text-white hover:bg-white hover:text-[#D4AF37] border border-[#D4AF37]"
                                  : "border border-[#123524] text-[#123524] hover:bg-[#123524] hover:text-white"
                                }
                     `}
                            >
                              Add to Cart
                            </button>
                          </Bottom>
                        </CardTopSelling>
                      );
                    })}
                </Slider>
              </SimilarProductsSlider>
            </SimilarProductsSection>
          </main>

          <ScrollToTop />
        </div>
      ) : (
        <BuyNow
          data={data}
          count={count}
          handleIncrement={handleIncrement}
          handleDecrement={handleDecrement}
        />
      )}
    </>
  );
}

// Styled Components
const Breadcrumb = styled.div`
  padding: 20px 0;
  font-family: 'Jost', sans-serif;
  font-size: 13px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #c5a880;
  max-width: 1200px;
  margin: 0 auto;

  a {
    color: #666;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: #123524;
    }
  }
`;

const ProductContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  padding: 20px 0;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const ProductHeader = styled.div`
  margin-bottom: 24px;
`;

const ProductTitle = styled.h1`
  font-family: "Jost", sans-serif;
  font-weight: 500;
  font-style: normal; /* "Medium" maps to weight 500 */
  font-size: 24px;
  line-height: 26px;
  letter-spacing: 0;
  color: #333;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;

  @media (max-width: 768px) {
    font-size: 22px;
    line-height: 24px;
  }
`;

const ProductSubtitle = styled.p`
  color: #666;
  font-size: 16px;
  margin-bottom: 16px;
`;

const RatingContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

const ReviewCount = styled.span`
  margin-left: 10px;
  color: #666;
  font-size: 14px;
`;

const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

const DiscountBadge = styled.span`
  background: rgba(197, 168, 128, 0.12);
  color: #a87b05;
  border: 1px solid rgba(197, 168, 128, 0.25);
  padding: 4px 10px;
  border-radius: 30px;
  font-family: 'Jost', sans-serif;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
`;

const SellerInfo = styled.div`
  font-family: "Jost", sans-serif;
  font-weight: 500; /* Medium */
  font-style: normal;
  font-size: 14px;
  line-height: 26px;
  letter-spacing: 0;
  color: #666;
`;

const SellerLink = styled.span`
  font-family: "Jost", sans-serif;
  font-weight: 500; /* Medium */
  font-style: normal;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0;
  color: #000000;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const StockScarcityAlert = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(212, 175, 55, 0.08);
  border: 1px solid rgba(212, 175, 55, 0.2);
  color: #8c7623;
  padding: 8px 16px;
  border-radius: 8px;
  font-family: 'Jost', sans-serif;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 16px;
  width: fit-content;
  animation: pulse 2s infinite ease-in-out;

  &::before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    background-color: #D4AF37;
    border-radius: 50%;
  }

  @keyframes pulse {
    0%, 100% { opacity: 0.9; }
    50% { opacity: 1; transform: scale(1.01); }
  }
`;

const DeliveryDateEstimator = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  background: #FDFBF7;
  border: 1px dashed rgba(197, 168, 128, 0.4);
  border-radius: 12px;
  padding: 14px 18px;
  margin-top: 15px;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  color: #2D1F18;
`;

const DeliveryText = styled.div`
  display: flex;
  flex-direction: column;
  
  span.date {
    color: #123524;
    font-weight: 600;
    font-family: 'Jost', sans-serif;
  }

  span.label {
    color: #666;
    font-size: 11px;
    margin-bottom: 2px;
  }
`;

const TrustBadgesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-top: 20px;
  background: #F2ECE1;
  border-radius: 16px;
  padding: 16px;
  border: 1px solid rgba(197, 168, 128, 0.2);
`;

const TrustBadgeItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: 'Jost', sans-serif;
  font-size: 12px;
  color: #2D1F18;
  font-weight: 500;

  svg {
    color: #123524;
    font-size: 20px;
    flex-shrink: 0;
  }
`;

const ProductActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px 0;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
`;

const QuantitySelector = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const QuantityLabel = styled.span`
  font-weight: 500;
`;

const QuantityControl = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid rgba(197, 168, 128, 0.3);
  border-radius: 50px;
  overflow: hidden;
  background: #FDFBF7;
  padding: 2px;
`;

const QuantityButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 14px;
  color: #123524;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background: #F2ECE1;
    color: #C5A880;
  }
`;

const QuantityValue = styled.span`
  width: 40px;
  text-align: center;
  font-weight: 500;
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

// const AddToCartButton = styled.button`
//   display: flex;
//   align-items: center;
//   gap: 8px;
//   padding: 12px 24px;
//   background: #fc9800;
//   color: white;
//   border: none;
//   border-radius: 4px;
//   font-weight: 500;
//   cursor: pointer;
//   flex: 1;
//   justify-content: center;

//   &:hover {
//     background: #e58900;
//   }
// `;

const AddToCartButton = styled.button`
  width: auto;
  height: 56px;
  padding: 10px;
  background: transparent;
  color: #123524;
  border: 2px solid #123524;
  border-radius: 50px;
  font-family: "Jost", sans-serif;
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  flex: 1;

  &:hover {
    background: #123524;
    color: #FDFBF7;
    box-shadow: 0 4px 15px rgba(18, 53, 36, 0.2);
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const BuyNowButton = styled.button`
  width: auto;
  height: 56px;
  padding: 10px;
  background: linear-gradient(135deg, #D4AF37 0%, #C5A880 100%);
  color: #123524;
  border: none;
  border-radius: 50px;
  font-family: "Jost", sans-serif;
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  flex: 1;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(197, 168, 128, 0.35);
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const WishlistButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  background: #f8f8f8;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 20px;

  &:hover {
    background: #eee;
  }

  @media (max-width: 480px) {
    width: 100%;
    height: 48px;
  }
`;

const DeliveryInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const DeliveryOption = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;

  svg {
    font-size: 20px;
    color: #123524;
  }

  strong {
    display: block;
    margin-bottom: 2px;
  }

  p {
    margin: 0;
    color: #666;
  }
`;

const ReviewsSection = styled.div``;

const ReviewSummary = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: #f9f9f9;
  border-radius: 8px;
  margin-bottom: 24px;

  @media (max-width: 640px) {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
`;

const AverageRating = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const RatingValue = styled.span`
  font-size: 32px;
  font-weight: 700;
  color: #333;
`;

const RatingCount = styled.span`
  color: #666;
`;

const AddReviewButton = styled.button`
  padding: 10px 20px;
  background: #123524;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background: #0d261a;
  }
`;

const ReviewList = styled.div`
  margin-bottom: 40px;
`;

const ReviewItem = styled.div`
  display: flex;
  gap: 16px;
  padding: 20px 0;
  border-bottom: 1px solid #eee;
`;

const ReviewerAvatar = styled.div`
  flex-shrink: 0;
`;

const ReviewContent = styled.div`
  flex: 1;
`;

const ReviewerName = styled.h4`
  margin: 0 0 8px 0;
  font-weight: 500;
`;

const ReviewRating = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
`;

const ReviewDate = styled.span`
  color: #666;
  font-size: 14px;
`;

const ReviewText = styled.p`
  margin: 0;
  color: #444;
  line-height: 1.5;
`;

const NoReviews = styled.p`
  text-align: center;
  padding: 40px;
  color: #666;
  font-style: italic;
`;

const ReviewForm = styled.div`
  background: #f9f9f9;
  padding: 24px;
  border-radius: 8px;
`;

const FormTitle = styled.h4`
  margin: 0 0 16px 0;
`;

const RatingInput = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

const ReviewTextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  resize: vertical;
  margin-bottom: 16px;
  font-family: inherit;
`;

const SubmitReviewButton = styled.button`
  padding: 10px 20px;
  background: #123524;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background: #0d261a;
  }
`;

const SafetySection = styled.div`
  line-height: 1.6;
`;

const SafetyContent = styled.div`
  color: #444;

  p {
    margin-bottom: 16px;
  }
`;

const VendorSection = styled.div``;

const VendorHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

const VendorName = styled.h3`
  margin: 0;
  color: #333;
`;

const VendorRating = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
`;

const VendorInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const VendorDetail = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;

  svg {
    color: #123524;
    margin-top: 4px;
  }
`;

const VendorDescription = styled.p`
  color: #444;
  line-height: 1.6;
`;

const ViewAllLink = styled(Link)`
  color: #123524;
  text-decoration: none;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;

const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const ProductCard = styled.div`
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

// Styled Components
const ProductGalleryContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 15px;
  }
`;

const ThumbnailsColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100px;

  @media (max-width: 768px) {
    width: 100%;
    order: 2;
  }
`;

const ThumbnailsScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 450px;
  overflow-y: auto;
  padding-right: 5px;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer / Edge Legacy */

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    display: none;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  @media (max-width: 768px) {
    flex-direction: row;
    max-height: unset;
    overflow-x: auto;
    overflow-y: hidden;
    padding-bottom: 10px;
    padding-right: 0;

    &::-webkit-scrollbar {
      height: 4px;
    }
  }
`;

const ThumbnailContainer = styled.div`
  position: relative;
  width: 100px;
  height: 100px;

  @media (max-width: 768px) {
    width: 80px;
    height: 80px;
  }

  @media (max-width: 480px) {
    width: 70px;
    height: 70px;
  }
`;

const ThumbnailShimmer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  border-radius: 6px;
  animation: shimmer 1.5s infinite;

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

const Thumbnail = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: 1px solid rgba(197, 168, 128, 0.2);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  position: absolute;
  top: 0;
  left: 0;

  &:hover,
  &.active {
    border-color: #D4AF37;
    box-shadow: 0 4px 10px rgba(212, 175, 55, 0.15);
    transform: scale(1.04);
  }

  &.loading {
    opacity: 0;
  }

  &.loaded {
    opacity: 1;
  }
`;

const MainImageContainer = styled.div`
  position: relative;
  flex: 1;
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;

  /* Default height for desktop */
  height: 500px;
  max-height: 500px;
  width: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    padding: 20px;
    transition: opacity 0.3s ease;
  }

  /* Large desktop */
  @media (min-width: 1440px) {
    height: 550px;
    max-height: 550px;
  }

  /* Standard desktop */
  @media (min-width: 1024px) and (max-width: 1439px) {
    height: 500px;
    max-height: 500px;
  }

  /* Tablet landscape */
  @media (min-width: 768px) and (max-width: 1023px) {
    height: 450px;
    max-height: 450px;

    img {
      padding: 18px;
    }
  }

  /* Tablet portrait */
  @media (min-width: 600px) and (max-width: 767px) {
    height: 400px;
    max-height: 400px;

    img {
      padding: 16px;
    }
  }

  /* Mobile landscape */
  @media (min-width: 480px) and (max-width: 599px) {
    height: 350px;
    max-height: 350px;
    width: 90vw;
    max-width: 100vw;
    border-radius: 0;
    border-left: none;
    border-right: none;

    img {
      padding: 15px;
    }
  }

  /* Mobile portrait */
  @media (max-width: 479px) {
    height: 300px;
    max-height: 300px;
    width: 90vw;
    max-width: 100vw;
    border-radius: 0;
    border-left: none;
    border-right: none;

    img {
      padding: 12px;
    }
  }

  /* Small mobile */
  @media (max-width: 360px) {
    height: 250px;
    max-height: 250px;
    width: 90vw;
    max-width: 100vw;
    border-radius: 0;
    border-left: none;
    border-right: none;

    img {
      padding: 10px;
    }
  }
`;

const WishlistIcon = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 9;
  background: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: all 0.2s ease;

  svg {
    font-size: 24px;
    color: #555;
  }

  &:hover {
    background: #f8f8f8;
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
    top: 12px;
    right: 12px;

    svg {
      font-size: 20px;
    }
  }

  @media (max-width: 480px) {
    width: 32px;
    height: 32px;
    top: 10px;
    right: 10px;

    svg {
      font-size: 18px;
    }
  }
`;

const NavigationButtons = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  background: rgba(255, 255, 255, 0.9);
  padding: 6px;
  border-radius: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  @media (max-width: 768px) {
    bottom: 15px;
    padding: 5px;
    gap: 8px;
  }

  @media (max-width: 480px) {
    bottom: 12px;
    padding: 4px;
    gap: 6px;
  }
`;

const NavButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;

  svg {
    font-size: 20px;
    color: #333;
  }

  &:hover {
    background: #f8f8f8;
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    width: 36px;
    height: 36px;

    svg {
      font-size: 18px;
    }
  }

  @media (max-width: 480px) {
    width: 32px;
    height: 32px;

    svg {
      font-size: 16px;
    }
  }
`;

const ImageCounter = styled.div`
  position: absolute;
  bottom: 20px;
  right: 20px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;

  @media (max-width: 768px) {
    bottom: 15px;
    right: 15px;
    padding: 4px 10px;
    font-size: 13px;
  }

  @media (max-width: 480px) {
    bottom: 12px;
    right: 12px;
    padding: 3px 8px;
    font-size: 12px;
  }
`;

const MainImageShimmer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

const ProductDetailsTabs = styled.div`
  border: 1px solid rgba(197, 168, 128, 0.15);
  border-radius: 16px;
  overflow: hidden;
  background: #FDFBF7;
  box-shadow: 0 4px 20px rgba(45, 31, 24, 0.02);
  margin-top: 24px;
`;

const TabButtons = styled.div`
  display: flex;
  border-bottom: 1px solid rgba(197, 168, 128, 0.15);
  background: #F2ECE1;

  @media (max-width: 640px) {
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

const TabButton = styled.button`
  padding: 14px 24px;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  font-family: 'Jost', sans-serif;
  font-weight: 600;
  font-size: 13px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  cursor: pointer;
  color: ${(props) => (props.active ? "#123524" : "#666")};
  border-bottom-color: ${(props) => (props.active ? "#D4AF37" : "transparent")};
  white-space: nowrap;
  transition: all 0.3s ease;

  &:hover {
    color: #123524;
    background: rgba(212, 175, 55, 0.05);
  }

  @media (max-width: 480px) {
    padding: 10px 12px;
    font-size: 12px;
  }
`;

const TabContent = styled.div`
  max-height: 400px;
  overflow-y: auto;
  padding: 16px;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  @media (max-width: 768px) {
    max-height: 350px;
    padding: 12px;
  }

  @media (max-width: 480px) {
    max-height: 300px;
    padding: 10px;
  }
`;

// Updated font sizes for minimal appearance
const DescriptionSection = styled.div`
  line-height: 1.5;
  font-size: 13px;
`;

const DescriptionContent = styled.div`
  color: #444;
  margin-bottom: 16px;
  font-size: 13px;

  p {
    margin-bottom: 12px;
  }

  ul,
  ol {
    margin-left: 16px;
    margin-bottom: 12px;
  }

  li {
    margin-bottom: 6px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 14px;
    margin-bottom: 8px;
  }
`;

const SectionTitle = styled.h3`
  font-family: "Playfair Display", serif;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  line-height: 1.3;
  letter-spacing: 0.01em;
  color: #123524;
  margin-top: 16px;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1.5px solid rgba(197, 168, 128, 0.2);
`;

// Updated Similar Products Section
const SimilarProductsSection = styled.section`
  margin: 0;
  max-width: 800px;
  width: 100%;

  @media (max-width: 1200px) {
    max-width: 100%; 
  }

  @media (max-width: 968px) {
    max-width: 100%;
  }

  @media (max-width: 768px) {
    max-width: 100%;
  }

  @media (max-width: 480px) {
    max-width: 100%;
  }
`;
const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const SliderNavigation = styled.div`
  display: flex;
  gap: 8px;
`;

const SimilarProductsSlider = styled.div`
  max-width: 800px;
  width: 100%;
  margin: 0 auto;

  .slick-slide {
    padding: 0 8px;
  }

  .slick-list {
    margin: 0 -8px;
  }

  .slick-track {
    display: flex;
    align-items: stretch;
  }

  .slick-slide {
    height: auto;

    & > div {
      height: 100%;
    }
  }

  /* Large desktop */
  @media (min-width: 1440px) {
    max-width: 800px;
    width: 100%;
  }

  /* Standard desktop */
  @media (min-width: 1200px) and (max-width: 1439px) {
    max-width: 750px;
    width: 100%;
  }

  /* Small desktop */
  @media (min-width: 1024px) and (max-width: 1199px) {
    max-width: 90vw;
    width: 100%;
  }

  /* Tablet landscape */
  @media (min-width: 968px) and (max-width: 1023px) {
    max-width: 650px;
    width: 100%;
  }

  /* Tablet portrait */
  @media (min-width: 768px) and (max-width: 967px) {
    width: 90vw;
    max-width: 100vw;
    .slick-slide {
      padding: 0 7px;
    }

    .slick-list {
      margin: 0 -7px;
    }
  }

  /* Mobile landscape */
  @media (min-width: 600px) and (max-width: 767px) {
    width: 90vw;
    max-width: 100vw;
    .slick-slide {
      padding: 0 6px;
    }

    .slick-list {
      margin: 0 -6px;
    }
  }

  /* Mobile portrait */
  @media (min-width: 480px) and (max-width: 599px) {
    width: 90vw;
    max-width: 100vw;
    .slick-slide {
      padding: 0 5px;
    }

    .slick-list {
      margin: 0 -5px;
    }
  }

  /* Small mobile */
  @media (min-width: 375px) and (max-width: 479px) {
    width: 90vw;
    max-width: 100vw;
    .slick-slide {
      padding: 0 4px;
    }

    .slick-list {
      margin: 0 -4px;
    }
  }

  /* Extra small mobile */
  @media (max-width: 374px) {
    width: 90vw;
    max-width: 100vw;
    .slick-slide {
      padding: 0 3px;
    }

    .slick-list {
      margin: 0 -3px;
    }
  }
`;

const SimilarProductCard = styled.div`
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;
  background: white;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

// Keep all other existing styled components...

// Updated responsive styles
const ProductImage = styled.img`
  width: 100%;
  height: 160px;
  object-fit: contain;
  padding: 12px;
  cursor: pointer;

  @media (max-width: 768px) {
    height: 140px;
  }
`;

const ProductName = styled.h4`
  margin: 0 0 6px 0;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  line-height: 1.3;

  &:hover {
    color: #123524;
  }
`;

const ProductCategory = styled.p`
  color: #666;
  font-size: 12px;
  margin: 0 0 6px 0;
`;

const ProductRating = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
`;


const CurrentPrice = styled.span`
  font-family: 'Jost', sans-serif;
  font-weight: 500; /* Medium */
  font-style: normal;
  font-size: 24px;
  line-height: 26px;
  letter-spacing: 0;
  color: #000000;
`;


const OriginalPrice = styled.span`
  font-family: 'Jost', sans-serif;
  font-weight: 400; /* Regular */
  font-style: normal;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 0;
  color: #999;
  text-decoration: line-through;
`;


const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  // gap: 30px;
`;

const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

//

const CardTopSelling = styled.div`
  // border: 1px solid rgb(229, 229, 229);
  border-radius: 23px;
  overflow: hidden;
  min-height: 375px;
  max-width: 290px;
  p {
    min-height: 35px;
    font-family: Poppins;
    font-weight: 500;
    font-style: Medium;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0%;
    color: rgba(0, 0, 0, 1);
  }
  &.fullHeight {
    height: 100%;
  }
`;

const Top = styled.div`
  position: relative;
  background-color: #fff;
  min-height: 150px;
`;
const Bottom = styled.div`
  padding: 10px 20px;
  border-radius: 0 0 10px 8px;

  &.withWhite {
    background-color: #fff;
  }
  &.withbg {
    background-color: #ad4b0e;
    p,
    h3 {
      color: #fff;
      font-size: 22px;
      padding: 10px 0;
      font-weight: 600;
    }
  }
  &.withbg-right {
    background-color: #ad4b0e;
    p,
    h3 {
      color: #fff;
      font-size: 15px;
      padding: 10px 0;
      font-weight: 400;
    }
  }
`;

const RatingBox = styled.div`
  position: absolute;
  top: 7px;
  left: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 24px;
  border-radius: 4px;
  gap: 2px;
  padding: 0 8px;
  background-color: #123524; /* Premium Emerald Green */
  font-size: 12px;
  font-weight: 500;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  z-index: 2;
`;
const LikeBox = styled.div`
  position: absolute;
  top: 7px;
  right: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 24px;

  z-index: 2;
`;

const CardImageContainer = styled.div`
  // margin-top: 10px;
  height: 200px;
  width: 100%;
  img {
    height: 100%;
    width: 100%;
    object-fit: contain;

    display: block;
  }
  @media screen and (max-width: 420px) {
    height: 150px;
    width: unset;
    img {
      object-fit: contain;
    }
  }
  &.top-selling {
    img {
      object-fit: cover;
    }
    @media screen and (max-width: 420px) {
      height: 210px;
      width: unset;
    }
  }
  &.fullHeight {
    /* height: calc(100% - 170px); */
  }
`;
export default ProductFullWidthNew;
